import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://cachorro-sin-crisis.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-187">
      <div className="max-w-3xl mx-auto" data-id="element-188">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-emerald-500/30 text-center relative overflow-hidden" data-id="element-189">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-190">
            <ShieldCheck className="w-64 h-64" data-id="element-191" />
          </div>
          <div className="relative z-10" data-id="element-192">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-193" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-194">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-195">
              Abrís los tomos. Los aplicás junto a tu cachorro.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-196">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-197" />
              <strong className="text-white" data-id="element-198">devolución del 100%</strong>
              <br data-id="element-199" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm text-emerald-400/80 font-medium" data-id="element-200">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para cualquier raza?',
    a: 'Sí. El kit está pensado para acompañar las necesidades esenciales de cachorros de cualquier raza. Podés adaptar cada rutina a su tamaño, energía y etapa de crecimiento.'
  }, {
    q: '¿Y si tiene solo 2 meses?',
    a: 'Sí, es un gran momento para empezar. Encontrarás pautas suaves y claras para las primeras rutinas, la adaptación al hogar y el aprendizaje desde cero.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Después de completar el pago recibís un email automático con el enlace de descarga en menos de 5 minutos. Podés verlo en el celular, la tablet o imprimirlo en casa.'
  }, {
    q: '¿Necesito experiencia?',
    a: 'No. Todo está explicado paso a paso, con propuestas simples para aplicar desde el primer día, aunque sea tu primer cachorro.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días completos sin preguntas. Si no estás satisfecho por cualquier motivo escribís a supportpuntodigital@gmail.com y te devolvemos el 100% del pago.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-201">
      <div className="max-w-3xl mx-auto" data-id="element-202">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-203">
          <span className="text-brand-400" data-id="element-204">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-205">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-206">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-207">
                <span className="font-bold text-white pr-8" data-id="element-208">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-209" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-210" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-211">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <div className="text-center mb-8" data-id="element-214">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-215">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-216" /> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-217">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-218">
            <thead data-id="element-219">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-220">
                <th className="p-4 text-slate-300 font-medium" data-id="element-221">
                  Sin una guía clara
                </th>
                <th className="p-4 text-red-400 font-bold" data-id="element-222">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-223">
              <tr data-id="element-224">
                <td className="p-4 text-slate-400" data-id="element-225">
                  Accidentes de pis repetidos durante las primeras semanas
                </td>
                <td className="p-4 text-white font-medium" data-id="element-226">
                  Limpieza, frustración y hábitos más difíciles de corregir
                </td>
              </tr>
              <tr data-id="element-227">
                <td className="p-4 text-slate-400" data-id="element-228">
                  Noches interrumpidas y una rutina sin orden
                </td>
                <td className="p-4 text-white font-medium" data-id="element-229">
                  Descanso de toda la familia afectado
                </td>
              </tr>
              <tr data-id="element-230">
                <td className="p-4 text-slate-400" data-id="element-231">
                  Mordidas y destrozos por aburrimiento o ansiedad
                </td>
                <td className="p-4 text-white font-medium" data-id="element-232">
                  Objetos dañados y más estrés en casa
                </td>
              </tr>
              <tr data-id="element-233">
                <td className="p-4 text-slate-400" data-id="element-234">
                  Consejos contradictorios sin una estrategia
                </td>
                <td className="p-4 text-white font-medium" data-id="element-235">
                  Tiempo perdido y avances que no se sostienen
                </td>
              </tr>
              <tr data-id="element-236">
                <td className="p-4 text-slate-400" data-id="element-237">
                  Reaccionar tarde ante señales de salud importantes
                </td>
                <td className="p-4 text-white font-medium" data-id="element-238">
                  Preocupación innecesaria y decisiones bajo presión
                </td>
              </tr>
              <tr data-id="element-239">
                <td className="p-4 text-slate-400" data-id="element-240">
                  Una familia frustrada en vez de disfrutar sus primeros meses
                </td>
                <td className="p-4 text-white font-medium" data-id="element-241">
                  Menos calma, vínculo y bienestar compartido
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-242">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-243">
            Esta semana puede ser diferente.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-244">
            "La diferencia entre criar con caos y criar con confianza no es la
            suerte. Es tener una guía clara desde el comienzo."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-245">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-246">
            <Clock className="w-5 h-5" data-id="element-247" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-248">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-249">
              <h4 className="font-bold text-white mb-2" data-id="element-250">
                PUNTO DIGITAL™ — KIT PARA CACHORRO
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-251">
                6 Tomos + 5 Bonos · Un comienzo más tranquilo
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-252">
                <span className="text-slate-500 line-through text-sm" data-id="element-253">
                  49990
                </span>
                <span className="text-3xl font-black text-white" data-id="element-254">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-255">ARS</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-256">
                → QUIERO MI KIT PARA CACHORRO
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-257">
            <span className="flex items-center" data-id="element-258">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-259" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-260">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-261" /> Acceso en 5
              minutos
            </span>
            <span className="flex items-center" data-id="element-262">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-263" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-264">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-265" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-266">
      <div className="max-w-4xl mx-auto text-center" data-id="element-267">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-268">
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-269">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-270">
          El kit de educación y bienestar para familias argentinas que quieren
          criar a su cachorro con más calma, criterio y confianza.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-271">
          Porque sus primeros meses merecen una guía que acompañe a toda la
          familia.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-272">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-273">
            supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-274">
            www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-275">
          <p data-id="element-276">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-277">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-278">
          <p className="text-brand-500/50 font-medium italic" data-id="element-279">
            "Esta semana puede ser diferente."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-280">
            "Un cachorro feliz empieza con una familia acompañada."
          </p>
        </div>
      </div>
    </footer>;
}